import React from 'react';
import {NavLink} from "react-router-dom";
import {AuthService} from "../../service/AuthService";
import {scrollTo} from "../../service/ToolsService";

export const Sidebar = () => {

  return (
    <>
      <div className="__admin_sidebar__ w180px">
        <div className="d-flex flex-column">
          { AuthService.hasRole('ROLE_USER') && (
            <div className="__admin_sidebar_menu__ __admin_sidebar_menu_hover__">
              <NavLink to="/admin/user" onClick={scrollTo}>
                <i className="fa-solid fa-user-secret me-1"/>
                Utilisateur
              </NavLink>
            </div>
          )}

          { AuthService.hasRole('ROLE_ACTUALITE') && (
            <div className="__admin_sidebar_menu__ __admin_sidebar_menu_hover__">
              <NavLink to="/admin/news" onClick={scrollTo}>
                <i className="fa-solid fa-circle-info me-1"/>
                Actualité
              </NavLink>
            </div>
          )}

          { AuthService.hasRole('ROLE_ALBUM') && (
            <div className="__admin_sidebar_menu__ __admin_sidebar_menu_hover__">
              <NavLink to="/admin/album" onClick={scrollTo}>
                <i className="fa-regular fa-images me-1"/>
                Album photo
              </NavLink>
            </div>
          )}

          { AuthService.hasRole('ROLE_PARCOURS') && (
            <div className="__admin_sidebar_menu__ __admin_sidebar_menu_hover__">
              <NavLink to="/admin/route/route" onClick={scrollTo}>
                <i className="fa-solid fa-person-biking me-1"/>
                Parcours
              </NavLink>
            </div>
          )}

          {AuthService.hasRole('ROLE_CALENDRIER') && (
            <div className="__admin_sidebar_menu__ __admin_sidebar_menu_hover__">
              <NavLink to="/admin/season" onClick={scrollTo}>
                <i className="fa-solid fa-calendar-day me-1"/>
                Calendrier
              </NavLink>
            </div>
          )}

          { AuthService.hasRole('ROLE_EQUIPEMENT') && (
            <div className="__admin_sidebar_menu__ __admin_sidebar_menu_hover__">
              <NavLink to="/admin/equipment/equipment" onClick={scrollTo}>
                <i className="fa-solid fa-shirt me-1"/>
                Equipement
              </NavLink>
            </div>
          )}

          { AuthService.hasRole('ROLE_BUREAU') && (
            <div className="__admin_sidebar_menu__ __admin_sidebar_menu_hover__">
              <NavLink to="/admin/office/office" onClick={scrollTo}>
                <i className="fa-solid fa-users-line me-1"/>
                Bureau
              </NavLink>
            </div>
          )}

          { AuthService.hasRole('ROLE_BUREAU') && (
            <div className="__admin_sidebar_menu__ __admin_sidebar_menu_hover__">
              <NavLink to="/admin/document" onClick={scrollTo}>
                <i className="fa-regular fa-file-pdf me-1"/>
                Licence
              </NavLink>
            </div>
          )}

          { AuthService.hasRole('ROLE_PARTENAIRE') && (
            <div className="__admin_sidebar_menu__ __admin_sidebar_menu_hover__">
              <NavLink to="/admin/partner" onClick={scrollTo}>
                <i className="fa-solid fa-handshake me-1"/>
                Partenaire
              </NavLink>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
